import EvaluationStarsSubtypeDetails from "../details/EvaluationStarsSubtypeDetails";
import { BaseModuleSubtype } from "../../../../../../types/actionModule/subtypes/subtype";
import { EvaluationStarsSubtypeDataModel } from "../../../../../../types/actionModule/subtypes/evaluationStarsSubtype";

interface Props {
    subtype: BaseModuleSubtype;
    subtypeData: EvaluationStarsSubtypeDataModel;
}

export default function EvaluationStarsSubtypeSummary(props: Props) {
    return <EvaluationStarsSubtypeDetails {...props} />
}
